import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import Cache from "i18next-localstorage-cache";
import LanguageDetector from "i18next-browser-languagedetector";
import packageJson from "../../package.json";
import { DEFAULT_LANGUAGE, availableLanguages } from "./languages";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(Cache)
  .use(initReactI18next)
  .init({
    lng: DEFAULT_LANGUAGE, // default language
    fallbackLng: DEFAULT_LANGUAGE, // fallback language
    detection: { checkWhitelist: true },
    debug: false,
    whitelist: availableLanguages,
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
    // TODO: Add namespace files
    // ns: ['common', 'operating-manual'], // All namespaces to load
    // defaultNS: 'common', // Default namespace
    backend: {
      // locale file path to use
      // update the translation cache when the version number has changed
      loadPath: `/locales/{{lng}}/translation.json?version=${packageJson.version}`,
    },
    cache: {
      // update the translation cache every 6 hours, even if the version number hasn't changed
      enabled: true,
      expirationTime: 6 * 60 * 60 * 1000, // 6 hours in milliseconds
    },
  });

export default i18n;
